export const HOMES_LOCALES = 'HOMES_LOCALES';
